// extracted by mini-css-extract-plugin
export var checkboxWrapper = "Checkbox-module--checkbox-wrapper--d0c25";
export var errorText = "Checkbox-module--error-text--e9832";
export var label = "Checkbox-module--label--363ce";
export var rightAlignedCheckbox = "Checkbox-module--right-aligned-checkbox--9fa00";